export const CHAT_ACTIONS = {
    DASHBOARD_STATS_PROCESS : "DASHBOARD_STATS_PROCESS",
    DASHBOARD_STATS_SUCCESS : "DASHBOARD_STATS_SUCCESS",
    DASHBOARD_STATS_FAILED : "DASHBOARD_STATS_FAILED",

}   

export const CHAT_ENDPOINTS = {
    GET_DASHBOARD_STATS : "dashboard/dashboard-statistics",
}